import React from 'react';
import { Box } from '@mui/material';
import CanvasCardFrame, { CanvasCardDragSharedProps } from './CanvasCardFrame';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

function CanvasGridCardBase({
	position,
	isSelected,
	scale,
	collectionColor,
	isPositionLocked,
	onPositionChange,
	constrainPosition,
	onDragStart,
	onDragActivate,
	onDragMove,
	onDragEnd,
	cardNodeRef,
	onFocus,
	onBlur,
	onSelect,
}: CanvasCardDragSharedProps) {
	return (
		<CanvasCardFrame
			position={position}
			scale={scale}
			isSelected={isSelected}
			collectionColor={collectionColor}
			isPositionLocked={isPositionLocked}
			onPositionChange={onPositionChange}
			constrainPosition={constrainPosition}
			onDragStart={onDragStart}
			onDragActivate={onDragActivate}
			onDragMove={onDragMove}
			onDragEnd={onDragEnd}
			cardNodeRef={cardNodeRef}
			onFocus={onFocus}
			onBlur={onBlur}
			onSelect={onSelect}
			ariaLabel={'Grid'}
			sx={{ minWidth: 0, '& > .MuiBox-root': { color: 'text.secondary', transition: 'all 0.2s ease-in-out' }, '&:hover > .MuiBox-root': { color: 'primary.main', scale: 1.1, transform: 'rotate(-180deg)' } }}>
			<Box display="flex" flexDirection="column" alignItems="stretch" gap={0.25}>
				<GpsFixedIcon fontSize="small" />
			</Box>
		</CanvasCardFrame>
	);
}

/** Memoized so panning/zooming (which re-renders CanvasView every frame) doesn't also re-render every grid card — CanvasView keeps this card's props referentially stable across those frames specifically so this bail-out holds. */
export const CanvasGridCard = React.memo(CanvasGridCardBase);
export default CanvasGridCard;
